import React, { useContext } from 'react';
import { useHistory, Redirect } from 'react-router-dom';

import * as shopify from '../helpers/shopify';
import { SettingsContext } from '../contexts/index.jsx';
import { CreateAccountComp } from './CreateAccount/index.jsx';

const buildUrl = (step, inLanding) => {
  const arr = [''];

  if (!inLanding) {
    arr.push('create-account');
  }

  if (step > 1) {
    if (inLanding) {
      arr.push(step);
    } else {
      arr.push('step-' + (step));
    }
  }

  return arr.join('/')
}

const CreateAccount = ({ authentication, step, inLanding = false }) => {
  const history = useHistory();
  const { isShopify, isRetailCircle } = useContext(SettingsContext);

  const onAccountCreated = async function (data, phone) {
    if (isShopify) {
      shopify.notifySignUp(data.user, data.token);
    }

    if (!isRetailCircle) {
      authentication.login(data.user, data.token, true, { isNewAccount: true })
    } else {
      setStep(3, false, { user: data.user, token: data.token, phone: phone });
    }
  }

  const setStep = (step, redirect = false, state) => {
    if (redirect) {
      return <Redirect to={buildUrl(step, inLanding)} />
    }

    history.push(buildUrl(step), state);
  }

  return (
    <CreateAccountComp
      {...{
        buildUrl,
        onAccountCreated,
        step,
        setStep,
        inLanding,
        isRetailCircle,
      }}
    />
  )
}

export default CreateAccount
